// src/components/Control/ControlPanel/PeoplePanel.tsx
// Люди, которых робот помнит по одежде (person_node на Pi):
//   robot/<id>/people     -> {"people": [{"pid", "name", "created", "seen", "greeted"}]}
//   robot/<id>/people/cmd <- {"cmd": "remember", "name"?} (ближайший человек в кадре камеры 1),
//                            {"cmd": "rename", "pid", "name"}, {"cmd": "forget", "pid"}, {"cmd": "forget_all"}
// Узнавание грубое: по цветам одежды, в пределах дня; людей в похожей одежде путает.
import React, { useState } from 'react';
import * as zenoh from '@eclipse-zenoh/zenoh-ts';
import { useTelemetryState } from '../robot/RobotContext';

interface Known {
  pid: string;
  name: string;
  created: number;
  seen: number | null;
  greeted: number | null;
}

function ago(ms: number | null): string {
  if (!ms) return '—';
  const s = Math.max(0, Math.round((Date.now() - ms) / 1000));
  if (s < 60) return `${s} с назад`;
  if (s < 3600) return `${Math.round(s / 60)} мин назад`;
  if (s < 86400) return `${Math.round(s / 3600)} ч назад`;
  return new Date(ms).toLocaleDateString();
}

const PeoplePanel: React.FC<{ zenohSession: zenoh.Session | null; robotId: string }> = ({ zenohSession, robotId }) => {
  // Список — из общей телеметрии (robot/<id>/people)
  const people = useTelemetryState(t => t.known) as Known[] | null;
  const [name, setName] = useState('');

  const cmd = (c: object) =>
    zenohSession?.put(`robot/${robotId}/people/cmd`, JSON.stringify(c)).catch(err => console.warn('people cmd failed', err));

  if (!zenohSession) return null;
  return (
    <div className="feature-card people-panel">
      <h3><span>Знакомые по одежде</span></h3>
      <div style={{ display: 'flex', gap: 6, fontSize: 13 }}>
        <input type="text" value={name} maxLength={40} placeholder="имя (необязательно)"
               onChange={e => setName(e.target.value)} style={{ flex: 1, minWidth: 0, padding: '3px 6px' }} />
        <button onClick={() => { cmd({ cmd: 'remember', ...(name.trim() ? { name: name.trim() } : {}) }); setName(''); }}
                title="Запомнить ближайшего человека в кадре камеры 1 (он должен быть виден хотя бы полсекунды)">
          Запомнить этого человека
        </button>
      </div>
      {people === null ? (
        <div style={{ fontSize: 12, color: '#666', marginTop: 6 }}>Жду список от робота (обновляется раз в 10 с)…</div>
      ) : people.length === 0 ? (
        <div style={{ fontSize: 12, color: '#666', marginTop: 6 }}>Робот пока никого не помнит. Тех, с кем поздоровался, он запоминает сам.</div>
      ) : (
        <table style={{ width: '100%', fontSize: 12, marginTop: 6, borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ color: '#777', textAlign: 'left' }}><th>Имя</th><th>Видел</th><th>Здоровался</th><th /></tr>
          </thead>
          <tbody>
            {people.map(p => (
              <tr key={p.pid} style={{ borderTop: '1px solid #eee' }}>
                <td>{p.name}</td>
                <td>{ago(p.seen)}</td>
                <td>{ago(p.greeted)}</td>
                <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button type="button" aria-label={`Переименовать ${p.name}`} style={{ fontSize: 11 }} onClick={() => {
                    const n = window.prompt('Новое имя', p.name);
                    if (n && n.trim()) cmd({ cmd: 'rename', pid: p.pid, name: n.trim() });
                  }}>✎</button>
                  <button type="button" aria-label={`Переименовать ${p.name}`} style={{ fontSize: 11 }} onClick={() => { if (window.confirm(`Забыть «${p.name}»?`)) cmd({ cmd: 'forget', pid: p.pid }); }}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {people && people.length > 0 && (
        <button style={{ fontSize: 11, marginTop: 6 }} onClick={() => { if (window.confirm('Забыть всех?')) cmd({ cmd: 'forget_all' }); }}>
          Забыть всех
        </button>
      )}
    </div>
  );
};

export default PeoplePanel;
